import React, { Component } from 'react'
import Button from '../components/Button'
import { func, number, string, bool } from 'prop-types'
import idportenLogo from '../assets/idporten_negativ_50x50.png'
import { isMobile } from 'react-device-detect'
import { strings } from '../localization'

export default class Login extends Component {

	decodeStringToHtml = string => {
		return <div className='invalidMessage' dangerouslySetInnerHTML={{ __html: string }} />
	}

	render() {
		const { logoutFeedbackFailure, logoutFeedbackSuccess, isLogoutFailure, isLogoutSuccess } = this.props

		return (
			<div className='login-container'>
				<h2>{strings.header}</h2>

				<p className='infotext'>
					{strings.infotext}
				</p>

				<form>
					<input type="hidden" name="doLogin" value='Logg inn via ID-porten' />

					<Button
						buttontext="Logg inn via ID-porten"
						buttontype="submit"
						additionalClass={'loginButton'}
						imgAfter={idportenLogo} 
						imgAfterAlt="Mattilsynet logo" />
				</form>

				{isLogoutSuccess && this.decodeStringToHtml(logoutFeedbackSuccess)}
				{isLogoutFailure && this.decodeStringToHtml(logoutFeedbackFailure)}

				{!isMobile &&
					<div className='infotext-notOnMobile'>
						<hr />

						<h3>{strings.first.header}</h3>

						<p>
							{strings.first.info}<a href="https://www.mattilsynet.no/skjema/">www.mattilsynet.no/skjema</a>
						</p>
					</div>
				}

			</div>
		)
	}
}